<div class="w-full">
  @for (table of prismicTable().slice(0, 2); track table) {
    <div class="flex flex-col text-base text-[--color-text-primary] text-left">
      <lib-product-card-bullet-list [brand]="brand" class="block px-3 mt-4 mb-5">
        @if (table.section_icon && table.section_title) {
          <lib-product-card-bullet-list-header [icon]="table.section_icon">{{
            table.section_title
          }}</lib-product-card-bullet-list-header>
        }
        @for (item of table.items.slice(0, 3); track item) {
          <lib-product-card-bullet-list-item [isOfferBox]="false">
            <p>{{ item.features_item }}</p>
          </lib-product-card-bullet-list-item>
        }
      </lib-product-card-bullet-list>
    </div>
  }
</div>
